// extracted by mini-css-extract-plugin
module.exports = {"dotTileExtraSmallViewport":"MyReports_dotTileExtraSmallViewport__2eIIF","dotTileDefaultViewport":"MyReports_dotTileDefaultViewport__3SWYB"};